const Success = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" rx="30" fill="#76C669" />
      <path
        d="M44 22C44 22.5117 43.8047 23.0237 43.4141 23.4137L27.4141 39.4137C27.025 39.8062 26.5125 40 26 40C25.4875 40 24.9763 39.8047 24.5863 39.4141L16.5863 31.4141C16.1956 31.025 16 30.5125 16 30C16 28.8575 16.9344 28 18 28C18.5117 28 19.0238 28.1953 19.4138 28.5859L26 35.175L40.5875 20.5875C40.975 20.1956 41.4875 20 42 20C43.0688 20 44 20.8563 44 22Z"
        fill="white"
      />
    </svg>
  );
};

export default Success;
